export default `
/*! scopecss-disable */
.shj-cs-float-panel {
  position: fixed;
  z-index: 1002;
  right: 30px;
  bottom: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25);
}
.shj-cs-float-panel.hidden {
  display: none;
  pointer-events: none;
}
.shj-float-panel-content-wrap {
  width: 190px;
  height: 218px;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  transition: all 500ms;
}
.shj-float-panel-content-wrap.small {
  height: 56px;
  display: flex;
  align-items: center;
}
.shj-float-panel-content-wrap.small .shj-float-panel-content {
  flex-direction: row;
  padding: 0 38px 0 15px;
  border-radius: 10px;
  justify-content: space-between;
  background-size: cover;
  background-repeat: no-repeat;
}
.shj-float-panel-content-wrap.small .shj-float-panel-content .shj-content-size-toggle {
  top: 50%;
  transform: translate(0, -50%);
}
.shj-float-panel-content-wrap.small .shj-float-panel-content .shj-content-size-toggle::before {
  border: 0;
  border-left: 1px solid #DBDDE1;
  border-top: 1px solid #DBDDE1;
  top: 0;
  left: -3px;
}
.shj-float-panel-content-wrap.small .shj-float-panel-content .shj-content-size-toggle::after {
  border: 0;
  border-right: 1px solid #DBDDE1;
  border-bottom: 1px solid #DBDDE1;
  top: 0;
  right: -2px;
}
.shj-float-panel-content-wrap.small .hangupIcon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.shj-float-panel-content-wrap .infoSmall {
  color: #fff;
}
.shj-float-panel-content-wrap .linkHook > * {
  pointer-events: none;
}
.shj-float-panel-content-wrap .infoSmallItem {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
}
.shj-float-panel-content-wrap .infoSmallItem .infoSmallText {
  transform-origin: center left;
  white-space: nowrap;
}
.shj-float-panel-content-wrap .infoSmallItem .textRight {
  min-width: 30px;
  height: 14px;
  line-height: 14px;
  font-size: 12px;
  color: #FFFFFF;
  font-weight: 400;
  margin-bottom: 1px;
}
.shj-float-panel-content-wrap .infoSmallItem .arrowRight {
  top: 50%;
  right: 0;
  transform: translate(0, -50%) rotate(45deg);
}
.shj-float-panel-content-wrap .statusSmallText,
.shj-float-panel-content-wrap .timeCountSmallText {
  font-size: 12px;
  color: #FFFFFF;
  font-weight: 400;
  white-space: nowrap;
  line-height: 15px;
}
.shj-float-panel-content-wrap .timeCountSmallText {
  font-weight: 500;
}
.shj-float-panel-content-wrap .shj-float-panel-content {
  width: 100%;
  height: 100%;
  border-radius: none;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  z-index: 10;
  transition: all 500ms;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
}
.shj-float-panel-content-wrap .shj-content-size-toggle {
  position: absolute;
  top: 12px;
  right: 15px;
  cursor: pointer;
}
.shj-float-panel-content-wrap .shj-content-size-toggle::before,
.shj-float-panel-content-wrap .shj-content-size-toggle::after {
  content: '';
  position: relative;
  display: block;
  width: 6px;
  height: 6px;
}
.shj-float-panel-content-wrap .shj-content-size-toggle::before {
  border-left: 1px solid #DBDDE1;
  border-bottom: 1px solid #DBDDE1;
  left: 5px;
  top: -1px;
  transition: all 500ms;
}
.shj-float-panel-content-wrap .shj-content-size-toggle::after {
  border-right: 1px solid #DBDDE1;
  border-top: 1px solid #DBDDE1;
  top: 2px;
  right: 4px;
  transition: all 500ms;
}
.shj-float-panel-content-wrap .shj-float-panel-time-count-text,
.shj-float-panel-content-wrap .shj-float-panel-status-text {
  text-align: center;
  line-height: 36px;
  color: #fff;
}
.shj-float-panel-content-wrap .shj-float-panel-status-text,
.shj-float-panel-content-wrap .shj-float-panel-time-count-text {
  font-size: 28px;
  color: #FFFFFF;
  font-weight: 400;
  margin: 30px 0 10px 0;
  line-height: 35px;
  min-height: 35px;
}
.shj-float-panel-content-wrap .infoWrap {
  color: #DBDFE2;
  width: 170px;
  height: 90px;
  border-radius: 5px;
  background-size: cover;
  display: flex;
  flex-direction: column;
}
.shj-float-panel-content-wrap .infoWrap .infoRow {
  display: flex;
  align-items: center;
  position: relative;
  flex: 1;
  line-height: 24px;
  font-weight: 400;
}
.shj-float-panel-content-wrap .infoWrap .infoRow .jumpTo {
  position: relative;
  width: 79%;
  cursor: pointer;
}
.shj-float-panel-content-wrap .infoWrap .label {
  width: 40px;
}
.shj-float-panel-content-wrap .infoWrap .text {
  font-size: 10px;
  transform: scale(0.8);
  transform-origin: center left;
  white-space: nowrap;
  width: 18%;
  padding-left: 10px;
}
.shj-float-panel-content-wrap .infoWrap .text.textOverflow {
  overflow: hidden;
  text-overflow: ellipsis;
}
.shj-float-panel-content-wrap .infoWrap .text.textRight {
  min-width: 110px;
  padding-left: 0;
}
.shj-float-panel-content-wrap .arrowRight {
  width: 5px;
  height: 5px;
  border-top: 1px solid #DBDFE2;
  border-right: 1px solid #DBDFE2;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%) rotate(45deg);
  right: 14px;
}
.shj-float-panel-content-wrap .hangupIcon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 170px;
  height: 28px;
  border-radius: 5px;
  margin: 10px 0;
  background: rgba(242, 90, 90, 0.9);
  transition: all 300ms;
  cursor: pointer;
}
.shj-float-panel-content-wrap .hangupIcon:focus,
.shj-float-panel-content-wrap .hangupIcon:active {
  opacity: 0.7;
}
.shj-float-panel-content-wrap .hangupText {
  font-size: 12px;
  color: #FFFFFF;
  font-weight: 500;
  pointer-events: none;
}
.shj-float-panel-content-wrap .hangupTextIcon {
  width: 20px;
  height: 20px;
  background-size: cover;
  pointer-events: none;
}

`